import { mapState } from 'vuex';
export default {
  name: 'CoreVirtualDeviceSmartGroupStatisticsCard',
  props: {
    id: {
      type: Number,
      required: true
    },
    last24Hours: {
      type: [Number, String],
      default: 0
    },
    prior24Hours: {
      type: [Number, String],
      default: 0
    },
    devices: {
      type: [Number, String],
      default: 0
    },
    errors: {
      type: [Number, String],
      default: 0
    },
    warnings: {
      type: [Number, String],
      default: 0
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      items: [1]
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    canEdit() {
      return this.actions.includes('edit');
    },
    canDelete() {
      return this.actions.includes('delete');
    }
  },
  watch: {},
  methods: {
    handleDelete(event) {
      event.target.blur();
      this.$emit('delete', this.id);
    },
    handleEdit(event) {
      event.target.blur();
      this.$emit('edit', this.id);
    }
  }
};